import type { Customer, TPatchCustomerBody } from '@payaca/types/customerTypes';
import type { ListedCustomersListViewPage } from '@payaca/types/listedCustomerTypes';
import type { FetchedEntity } from '@payaca/types/storeTypes';
import type { DeclareAsyncAction } from '../types';

export interface State {
  isPersistingCustomer: boolean;
  isCustomerPersistedSuccessfully?: boolean;
  currentCustomer?: Customer;
  isGettingCustomer: boolean;
  isGettingListedCustomersPage: boolean;
  listedCustomersPage: ListedCustomersListViewPage | null;

  customers: {
    [key: string]: FetchedEntity<Customer>;
  };
}

export enum ActionType {
  REQUEST_PERSIST_CUSTOMER = 'customer.requestPersistCustomer',
  PERSIST_CUSTOMER_SUCCESS = 'customer.persistCustomerSuccess',
  PERSIST_CUSTOMER_FAILURE = 'customer.persistCustomerFailure',

  REQUEST_GET_AND_SET_CURRENT_CUSTOMER = 'customer.requestGetAndSetCurrentCustomer',
  SET_CURRENT_CUSTOMER = 'customer.setCurrentCustomer',
  CLEAR_CURRENT_CUSTOMER = 'customer.clearCurrentCustomer',
  CLEAR_CUSTOMERS = 'customer.clearCustomers',

  REQUEST_GET_CUSTOMER = 'customer.requestGetCustomer',
  GET_CUSTOMER_SUCCESS = 'customer.getCustomerSuccess',
  GET_CUSTOMER_FAILURE = 'customer.getCustomerFailure',

  REQUEST_GET_LISTED_CUSTOMERS_PAGE = 'customer.requestGetListedCustomersPage',
  GET_LISTED_CUSTOMERS_PAGE_SUCCESS = 'customer.getListedCustomersPageSuccess',
  GET_LISTED_CUSTOMERS_PAGE_FAILURE = 'customer.getListedCustomersPageFailure',
  CLEAR_LISTED_CUSTOMERS_PAGE = 'customer.clearListedCustomersPage',

  PATCH_CUSTOMER_REQUEST = 'customer.putCustomer:request',
  PATCH_CUSTOMER_SUCCESS = 'customer.putCustomer:success',
  PATCH_CUSTOMER_FAILURE = 'customer.putCustomer:failure',
}

export interface SagaConfig {
  apiBaseurl: string;
  getAuthHeader: () => Promise<string>;
  isNativeApp?: boolean;
}

export type PatchCustomer = DeclareAsyncAction<
  ActionType,
  {
    request: {
      type: ActionType.PATCH_CUSTOMER_REQUEST;
      payload: {
        customerId: number;
        body: TPatchCustomerBody;
        callback?: (data: any) => void;
      };
    };
    success: {
      type: ActionType.PATCH_CUSTOMER_SUCCESS;
      payload: Customer;
    };
    failure: {
      type: ActionType.PATCH_CUSTOMER_FAILURE;
    };
  }
>;
